<template>
  <div>
    <div class="dker p-x">
      <div class="row">

        <div class="col-sm-6 pull-sm-6">
          <div class="p-y-md clearfix nav-active-primary">
            <ul class="nav nav-pills nav-sm">
              <li
                class="nav-item">
                <a
                  :class="{'disabled': loading}"
                  class="nav-link nav-coupon"
                  @click="switchView('coupons')">Vouchers</a>
              </li>
              <li
                class="nav-item">
                <a
                  :class="{'disabled': loading}"
                  class="nav-link nav-coupon"
                  @click="switchView('couponInvoices')">Voucher Claims</a>
              </li>
              <li
                class="nav-item">
                <a
                  :class="{'disabled': loading}"
                  class="nav-link nav-coupon"
                  @click="switchView('couponRedemptions')">Voucher Redemptions</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="padding">
      <keep-alive>
        <component
          ref="component"
          :is="currentView">
          <!-- component changes when vm.currentView changes! -->
        </component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import coupons from './vuetable_coupon.vue';
import couponInvoices from './coupon-invoices.vue';
import couponRedemptions from './coupon-redemptions.vue';
import { EventCoupon } from './coupon-event-bus';

export default {
    components: {
        coupons,
        couponInvoices,
        couponRedemptions,
    },

    props: {
        tab: {
            type: String,
            default: 'coupons',
        },
    },

    data: () => {
        return {
            currentView: 'coupons',
            loading: true,
        };
    },

    created() {
        this.currentView = this.tab;
        this.registerEvent();
    },
    methods: {
        switchView(view) {
            if (this.loading) {
                return;
            }

            $('.nav-coupon').attr('data-toggle', 'tab');
            this.currentView = view;
        },

        registerEvent() {
            var that = this;

            EventCoupon.$on('loaded', outlet => {
                that.loading = false;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/couponredeem/coupon-master.vue